function inferApiBaseUrl() {
    if (typeof window !== 'undefined' && window.location.hostname.endsWith('easyfastv.space')) {
        return 'https://api.easyfastv.space/api/';
    }
    return 'https://api.efv.me/api/';
}

export const server_api = process.env.REACT_APP_API_BASE_URL || inferApiBaseUrl();